import React from 'react';
import { ReactComponent as TasksIcon } from 'src/assets/navigation/activities.svg';
import { ReactComponent as CloudIcon } from 'src/assets/navigation/cloud.svg';
import { ReactComponent as CustomizeIcon } from 'src/assets/navigation/equalizer.svg';
import { ReactComponent as ReportsIcon } from 'src/assets/navigation/fileChart.svg';
import { ReactComponent as HealthIcon } from 'src/assets/navigation/health.svg';
import { ReactComponent as HomeIcon } from 'src/assets/navigation/home.svg';
import { ReactComponent as LeadsIcon } from 'src/assets/navigation/leads.svg';
import { ReactComponent as ListIcon } from 'src/assets/navigation/list.svg';
import { ReactComponent as LocationIcon } from 'src/assets/navigation/location.svg';
import { ReactComponent as MoneyIcon } from 'src/assets/navigation/money.svg';
import { ReactComponent as PerformanceIcon } from 'src/assets/navigation/performance.svg';
import { ReactComponent as SettingsIcon } from 'src/assets/navigation/settings.svg';
import { ReactComponent as TeamsIcon } from 'src/assets/navigation/teams.svg';
import { ReactComponent as UploadIcon } from 'src/assets/navigation/upload.svg';

export const iconsMap = {
  'home-page': <HomeIcon />,
  loan: <TasksIcon />,
  ccase: <LeadsIcon />,
  activity: <TasksIcon />,
  batch: <ListIcon />,
  payment: <MoneyIcon />,
  leads: <LeadsIcon />,
  'goal-bulk-upload': <UploadIcon />,
  masters: <ListIcon />,
  tasks: <TasksIcon />,
  common: <LocationIcon />,
  'manage-users': <TeamsIcon />,
  others: <CloudIcon />,
  reports: <ReportsIcon />,
  'client-health-dashboard': <HealthIcon />,
  customize: <CustomizeIcon />,
  settings: <SettingsIcon />,
  'bo-list': <ListIcon />,
  performance: <PerformanceIcon />,
};
